const translations = {
  subscribeButton: {
    en: 'UPGRADE TO SUBSCRIPTION & SAVE',
    de: 'ZUM ABONNEMENT UPGRADEN & SPAREN',
    fr: "PASSEZ À L'ABONNEMENT ET ÉCONOMISEZ",
    es: 'CAMBIA A SUSCRIPCIÓN Y AHORRA',
    it: "PASSA ALL'ABBONAMENTO E RISPARMIA",
  },
  oneTimePurchaseButton: {
    en: 'SWITCH TO ONE-TIME PURCHASE',
    de: 'ZU EINMALKAUF WECHSELN',
    fr: "PASSER À L'ACHAT UNIQUE",
    es: 'CAMBIAR A COMPRA ÚNICA',
    it: "PASSA ALL'ACQUISTO SINGOLO",
  },
  deliveryEvery: {
    en: 'Delivered<br/>every 30 days',
    de: 'Lieferung<br/>alle 30 Tage',
    fr: 'Livré<br/>tous les 30 jours',
    es: 'Entrega<br/>cada 30 días',
    it: 'Consegna<br/>ogni 30 giorni', 
  },
  savingText: {
    en: `You've saved`,
    de: 'Du hast',
    fr: 'Vous avez économisé',
    es: 'Has ahorrado',
    it: 'Hai risparmiato',
  },
  postPercentageText: {
     en: '',
    de: 'gespart',
    fr: '',
    es: '',
    it: ''
  }
};
export function getTranslation(key) {
  const userLang = Shopify.locale || 'en';
  const langCode = userLang.split('-')[0]; // Extract language code (e.g., 'en' from 'en-US')
  return translations[key][langCode] || translations[key]['en'];
}